export const studyProfilesArray = state => {
    let arr = Object.values(state.studyProfiles);
    arr.sort((a, b) => (a.ord > b.ord) ? 1 : -1);
    return arr
}
